/**
 * Esta página está dentro de um iframe ou de um popup nosso?
 *
 * ── Por que isto merece um módulo ─────────────────────────────────────────
 *
 * A resposta muda o que DOIS lugares fazem, e eles precisam concordar:
 *
 *   · a tela de retorno, que embutida repassa o resultado por `postMessage`
 *     em vez de trocar o código ela mesma;
 *   · o provedor de sessão, que embutido não faz nada.
 *
 * A função vivia duplicada nos dois. Enquanto as cópias concordaram, ninguém
 * notou; quando o provedor ganhou a checagem e a tela não, ou vice-versa, o
 * desacordo apareceria como sessão que não se estabelece — sem erro nenhum.
 *
 * ── O que o provedor de sessão evita com isto ─────────────────────────────
 *
 * `renovarEmSilencio` cria um iframe escondido apontando para o provedor de
 * identidade, que o redireciona para `/retorno`. E `/retorno` carrega A
 * APLICAÇÃO INTEIRA — inclusive o provedor de sessão, que então monta lá
 * dentro e dispara a própria primeira carga.
 *
 * O resultado são dois fluxos de autorização simultâneos gravando o pedido no
 * MESMO `sessionStorage`, porque a origem é a mesma. Um sobrescreve o `state`
 * do outro, a conferência de retorno recusa — corretamente, do ponto de vista
 * dela — e a sessão recém-obtida é descartada.
 *
 * O sintoma é o pior possível: o login funciona, o token é emitido, e a tela
 * volta para "Entrar" sem erro nenhum. Apareceu na primeira subida do ambiente
 * compartilhado, e não aparece em toda máquina porque depende de qual dos dois
 * fluxos escreve por último.
 *
 * ── As duas perguntas, e por que as duas ──────────────────────────────────
 *
 * `window.self !== window.top` cobre o iframe. `window.opener != null` cobre o
 * popup, que tem `self === top` e mesmo assim não é a aba principal — é o
 * caminho de reautenticação quando o iframe é bloqueado por política de
 * cookies de terceiros.
 */
export function estaEmbutido(janela: Window = window): boolean {
  return janela.self !== janela.top || janela.opener != null;
}
